module.exports = __webpack_public_path__ + "static/media/health-refill-medication.504ec3be.svg";